import { render, staticRenderFns } from "./inbound-email-failed-icon.vue?vue&type=template&id=290b1364"
import script from "./inbound-email-failed-icon.vue?vue&type=script&lang=js"
export * from "./inbound-email-failed-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports